import React from 'react'
import PropTypes from 'prop-types'

import { ThemeProvider, theme } from 'util/style'
import { GlobalStyles } from 'util/style/GlobalStyles'
import Header from 'components/Header'
import Footer from 'components/Footer'
import FooterSection from 'components/Footer/FooterSection'
import { Box, Container } from 'components/Grid'
import styled from 'util/style'

import config from '../../../config/meta'

const Wrapper = styled.div`
  display: block;
  overflow: hidden;
  position: relative;
`

const GreenBlock = styled.div`
  background: #d5eae7;
  width: 1300px;
  height: 270px;
  transform: rotate(10deg);
  position: absolute;
  top: -165px;
  right: -50px;
  z-index: 1;

  @media (max-width: 640px) {
    width: 500px;
    height: 150px;
    top: -120px;
  }
`

const Layout = ({ children, fullWidth }) => (
  <ThemeProvider theme={theme}>
    <Wrapper>
      <Header siteTitle={config.siteTitle || config.siteTitleAlt} />

      <GreenBlock />

      <Container maxWidth={fullWidth ? 'none' : '1040px'} px={3} style={{ padding: '0 20px' }}>
        {children}
      </Container>

      <Box mt={3}>
        <Footer>
          <FooterSection>
            <p>Ieder meisje heeft het recht om zich sterk, mooi en zelfverzekerd te voelen in haar eigen lichaam. Daarom bouwt Gutsy Fashion aan het platform voor fashionable and confident girls (to be)!<br /><br />Ready to empower each other? Join Gutsy Fashion!</p>
          </FooterSection>
          <FooterSection>
            <link href="//cdn-images.mailchimp.com/embedcode/slim-10_7.css" rel="stylesheet" type="text/css" />
            <div id="mc_embed_signup">
            <form action="https://fashion.us20.list-manage.com/subscribe/post?u=e2a2ce588da9a7332831d906e&amp;id=b25bd5de05" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll">
              <label for="mce-EMAIL">Blijf op de hoogte</label>
              <input type="email" name="EMAIL" class="email" id="mce-EMAIL" placeholder="Emailadres" required />
                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true"><input type="text" name="b_e2a2ce588da9a7332831d906e_b25bd5de05" tabindex="-1" value="" /></div>
                <div class="clear"><input type="submit" value="Inschrijven" name="subscribe" id="mc-embedded-subscribe" class="button" /></div>
                </div>
            </form>
            </div>
          </FooterSection>
          <FooterSection>
            <p>
              <a href="/about">Over Gutsy</a>
              <a href="/contact">Contact</a>
              <a href="/terms">Algemene voorwaarden</a>
              <a href="/privacy">Privacy verklaring</a>
            </p>
          </FooterSection>
        </Footer>
      </Box>
      <GlobalStyles />
    </Wrapper>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.node.fullWidth,
}

export default Layout
